module.exports = __webpack_public_path__ + "media/images/BIISublogo-b3cf277a.png";